import { NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import CheckQueryApiClient from "../../../ApiClients/CheckQueryApiClient";
import { AppService, Types } from "../../../../App/Services/AppService";



@NeoModel
export default class CheckQueryLookup extends ValueObject {
    public checkQueryId: number = 0;

    public checkQueryCode: string = "";

    @Rules.Required()
    @Rules.StringLength(1,500,"The Check Query Description has a limit of 500 characters ")
    public checkQueryDescription: string = "";

    public storedProcedureId: number = 0;
    
    @Rules.Required()
    public storedProcedureName: string = "";

    @Rules.Required()
    public tierId: number | null = null;

    public tierName: string = "";

    public apiClient: CheckQueryApiClient | null = AppService.get(Types.ApiClients.CheckQueryApiClient);

    protected addBusinessRules(rules: Validation.Rules<this>){
        super.addBusinessRules(rules);

        rules.infoWhen(c => c.checkQueryCode.length === 0, "Enter a code to check for availability")

        rules.add(this.asyncRule).onProperties(c => {
            return c.checkQueryCode;
        });
        rules.add(this.asyncRule).onProperties(c => {
            return c.checkQueryId;
        });
    }

    private asyncRule(context: Validation.IRuleContext){
        if(this.checkQueryCode!==null && this.apiClient !== null)
        {
            context.beginAsync("Checking Code Availability...", async asyncContext => {
                if(this.checkQueryCode.length>0)
                {
                    const response = await this.apiClient!.isCheckQueryCodeUnique(this.checkQueryCode, this.checkQueryId);
                    if(!response.data)
                    {
                        asyncContext.addError("This code already exists");
                    }
                    else
                    {
                        asyncContext.addMessage("This code is available");
                    }
                    asyncContext.endAsync();
                }
            })
        }
        
    }
}